import { render, staticRenderFns } from "./AnalysisBusinessRisk.vue?vue&type=template&id=5edcceca&"
import script from "./AnalysisBusinessRisk.vue?vue&type=script&lang=js&"
export * from "./AnalysisBusinessRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports